import { Link } from "react-router-dom";

export const TopVotedFights = ({ fights }) => {
  if (!fights || fights.length === 0) return null;

  return (
    <div>
      <h2 className="font-heading text-lg font-bold uppercase tracking-wider text-white mb-3">Most Voted Fights</h2>
      <div className="space-y-2">
        {fights.map((fight) => (
          <Link
            key={fight.FightID}
            to={`/fight/${fight.FightID}`}
            className="flex items-center justify-between bg-flyers-charcoal/50 border border-flyers-dark-gray rounded px-4 py-3 hover:border-flyers-orange/50 transition-colors duration-150"
          >
            <span className="text-white">
              {fight.Player1Details?.firstName} {fight.Player1Details?.lastName}
              <span className="text-flyers-orange mx-2 font-heading font-bold">vs</span>
              {fight.Player2Details?.firstName} {fight.Player2Details?.lastName}
            </span>
            <span className="text-flyers-orange font-heading font-bold text-sm">
              {fight.stats?.totalVotes || 0} votes
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};
